var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_804)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60516 17.5602H9.48568C10.0892 17.5602 10.6775 17.8842 11.1897 18.4909L11.6158 19H3.60516C2.72017 19 2 18.2698 2 17.3725V2.64291C2 1.74561 2.72017 1.01543 3.60516 1.01543L11.6158 1L11.1897 1.50907C10.675 2.11841 10.0841 2.43979 9.48568 2.43979L3.60516 2.45522C3.50373 2.45522 3.42005 2.53749 3.42005 2.64291V17.3725C3.42005 17.4754 3.50119 17.5602 3.60516 17.5602ZM12.5819 3.49907L19 10.0193L12.5819 16.4984L12.5743 15.8582C12.5692 15.092 12.7949 14.4518 13.2336 14.0096L16.5732 10.6466H9.7139C8.6159 10.6261 7.54072 10.3381 6.60248 9.80846L5.78595 9.35081H16.558L13.2336 5.98786C12.7949 5.54564 12.5641 4.90544 12.5743 4.13927L12.5819 3.49907Z",
    fill: "#051766"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon_logout.c5b67d14d294dc1cd8bb5b0681467e2b.svg";
export { ForwardRef as ReactComponent };